/*=========================================================================================
  File Name: moduleNotifyActions.js
  Description: Notify Module Actions
==========================================================================================*/

import api from "../../api/apiService"

export default {

    // notify list
    fetchNotify({ commit }) {
      return api.notify(true, 'list', {count: 200}, (res) => {
        if (res.success && res.msg == 'ok') {
          commit('SET_NOTIFY', res.data)
        }
      });
    },

    // // device
    // fetchDevice({ commit }, payload) {
    //   // commit('SET_DEVICE', {})
    //   return api.device(true, 'list', payload, (res) => {
    //     if (res.success && res.msg == 'ok') {
    //       commit('SET_DEVICE', res.data[0])
    //     }
    //   });
    // },

    // // device log
    // logDevice({ commit }, payload) {
    //   commit('SET_DEVICE_LOG', [])
    //   return api.device(true, 'log', payload, (res) => {
    //     if (res.success && res.msg == 'ok') {
    //       commit('SET_DEVICE_LOG', res.data)
    //     // } else if (res.msg == 'empty') {
    //       // commit('SET_DEVICE_LOG', [])
    //     }
    //   });
    // },

    // notify create
    createNotify({ commit }, payload) {
      let clid_str = '';
      let first = true;
      payload.clients.forEach(value => {
        if (!first) {
          clid_str += ','
        }
        first = false
        clid_str += value.clid
      })
      return api.notify(true, 'create', {
        clid: clid_str,
        header: payload.header,
        text: payload.text,
        type: payload.type,
      }, (res) => {
        if (res.success && res.msg == 'ok') {
          // payload.notid = res.notid;
          // commit('CREATE_NOTIFY', payload);
          api.emitNotifyEvent({
            title: 'Создание уведомления',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Создание уведомления',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },

    // notify create for all clients
    createNotifyAll({ commit }, payload) {
      // payload.all = 1;
      return api.notify(true, 'create', payload, (res) => {
        if (res.success && res.msg == 'ok') {
          // payload.notid = res.notid;
          // commit('CREATE_NOTIFY', payload);
          api.emitNotifyEvent({
            title: 'Создание уведомления',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Создание уведомления',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },

    // notify create for devices
    createNotifyDev({ commit }, payload) {
      let did_str = '';
      let first = true;
      payload.devices.forEach(value => {
        if (!first) {
          did_str += ','
        }
        first = false
        did_str += value.did
      })
      return api.notify(true, 'create', {
        did: did_str,
        header: payload.header,
        text: payload.text,
        type: payload.type,
      }, (res) => {
        if (res.success && res.msg == 'ok') {
          // payload.notid = res.notid;
          // commit('CREATE_NOTIFY', payload);
          api.emitNotifyEvent({
            title: 'Создание уведомления',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Создание уведомления',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },

    // notify edit
    publicNotify({ commit }, payload) {
      let notid_str = '';
      let first = true;
      payload.forEach(value => {
        if (!first) {
          notid_str += ','
        }
        first = false
        notid_str += value.notid
      })
      return api.notify(true, 'edit', {notid: notid_str, state: 1}, (res) => {
        if (res.success && (res.msg == 'ok' || res.msg == 'no change')) {
          // commit('UPDATE_NOTIFY', payload)
          api.emitNotifyEvent({
            title: 'Публикация уведомления',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Публикация уведомления',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },

    // notify delete
    deleteNotify({ commit }, payload) {
      let notid_str = '';
      let first = true;
      payload.forEach(value => {
        if (!first) {
          notid_str += ','
        }
        first = false
        notid_str += value.notid
      })
      return api.notify(true, 'delete', {notid: notid_str}, (res) => {
        if (res.success && res.msg == 'ok') {
          // commit('DELETE_DEVICE', payload)
          api.emitNotifyEvent({
            title: 'Удаление уведомления',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Удаление уведомления',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },

    // // devices delete
    // deleteDevices({ commit }, payload) {
    //   let did_str = '';
    //   let first = true;
    //   payload.forEach(value => {
    //     if (!first) {
    //       did_str += ','
    //     }
    //     first = false
    //     did_str += value.did
    //   })
    //   // api.device(true, 'delete', { did: did_str, debug: 1 }, (res) => {
    //   return api.device(true, 'delete', { did: did_str }, (res) => {
    //     if (res.success && res.msg == 'ok') {
    //       commit('DELETE_DEVICES', payload)
    //       api.emitNotifyEvent({
    //         title: 'Удаление устройств',
    //         text: "Выполнено успешно.",
    //         iconPack: 'feather',
    //         icon: 'icon-check-circle',
    //         color: 'success'
    //       });
    //     } else if (res.msg == 'constraint') {
    //       api.emitNotifyEvent({
    //         title: 'Удаление устройств',
    //         text: "Чтобы удалить устройства, их необходимо отвязать от партнера и от объекта.",
    //         iconPack: 'feather',
    //         icon: 'icon-alert-circle',
    //         color: 'danger'
    //       });
    //     } else {
    //       api.emitNotifyEvent({
    //         title: 'Удаление устройств',
    //         text: "Ошибка выполнения.",
    //         iconPack: 'feather',
    //         icon: 'icon-alert-circle',
    //         color: 'danger'
    //       });
    //     }
    //   });
    // },
    
    // // device log delete
    // deleteDeviceLog({ commit }, payload) {
    //   let lid_str = '';
    //   let first = true;
    //   payload.forEach(value => {
    //     if (!first) {
    //       lid_str += ','
    //     }
    //     first = false
    //     lid_str += value.lid
    //   })
    //   return api.device(true, 'deletelog', { lid: lid_str }, (res) => {
    //     if (res.success && res.msg == 'ok') {
    //       commit('DELETE_DEVICE_LOG', payload)
    //       api.emitNotifyEvent({
    //         title: 'Удаление сообщений устройства',
    //         text: "Выполнено успешно.",
    //         iconPack: 'feather',
    //         icon: 'icon-check-circle',
    //         color: 'success'
    //       });
    //     } else {
    //       api.emitNotifyEvent({
    //         title: 'Удаление сообщений устройства',
    //         text: "Ошибка выполнения.",
    //         iconPack: 'feather',
    //         icon: 'icon-alert-circle',
    //         color: 'danger'
    //       });
    //     }
    //   });
    // },
    
    // // devices disconnect
    // disconnectDevices({ commit }, payload) {
    //   let did_str = '';
    //   let first = true;
    //   payload.forEach(value => {
    //     if (!first) {
    //       did_str += ','
    //     }
    //     first = false
    //     did_str += value.did
    //   })
    //   return api.device(true, 'disconnect', { did: did_str }, (res) => {
    //     if (res.success && (res.msg == 'ok' || res.msg == 'no change')) {
    //       commit('', payload)
    //       api.emitNotifyEvent({
    //         title: 'Отключение устройств',
    //         text: "Выполнено успешно.",
    //         iconPack: 'feather',
    //         icon: 'icon-check-circle',
    //         color: 'success'
    //       });
    //     } else {
    //       api.emitNotifyEvent({
    //         title: 'Отключение устройств',
    //         text: "Ошибка выполнения.",
    //         iconPack: 'feather',
    //         icon: 'icon-alert-circle',
    //         color: 'danger'
    //       });
    //     }
    //   });
    // },
    
    // // devices enable
    // enableDevices({ commit }, payload) {
    //   let did_str = '';
    //   let first = true;
    //   payload.forEach(value => {
    //     if (!first) {
    //       did_str += ','
    //     }
    //     first = false
    //     did_str += value.did
    //   })
    //   return api.device(true, 'edit', { did: did_str, enable: 1 }, (res) => {
    //     if (res.success && (res.msg == 'ok' || res.msg == 'no change')) {
    //       commit('ENABLE_DEVICES', payload)
    //       api.emitNotifyEvent({
    //         title: 'Разрешение для устройств',
    //         text: "Выполнено успешно.",
    //         iconPack: 'feather',
    //         icon: 'icon-check-circle',
    //         color: 'success'
    //       });
    //     } else {
    //       api.emitNotifyEvent({
    //         title: 'Разрешение для устройств',
    //         text: "Ошибка выполнения.",
    //         iconPack: 'feather',
    //         icon: 'icon-alert-circle',
    //         color: 'danger'
    //       });
    //     }
    //   });
    // },

    // // devices disable
    // disableDevices({ commit }, payload) {
    //   let did_str = '';
    //   let first = true;
    //   payload.forEach(value => {
    //     if (!first) {
    //       did_str += ','
    //     }
    //     first = false
    //     did_str += value.did
    //   })
    //   return api.device(true, 'edit', { did: did_str, enable: 0 }, (res) => {
    //     if (res.success && (res.msg == 'ok' || res.msg == 'no change')) {
    //       commit('DISABLE_DEVICES', payload)
    //       api.emitNotifyEvent({
    //         title: 'Запрет для устройств',
    //         text: "Выполнено успешно.",
    //         iconPack: 'feather',
    //         icon: 'icon-check-circle',
    //         color: 'success'
    //       });
    //     } else {
    //       api.emitNotifyEvent({
    //         title: 'Запрет для устройств',
    //         text: "Ошибка выполнения.",
    //         iconPack: 'feather',
    //         icon: 'icon-alert-circle',
    //         color: 'danger'
    //       });
    //     }
    //   });
    // },

}
